import React, { useEffect } from "react";
import TypesOfQuestionsEnum from "./typesOfQuestionsEnum";
import TextResponseEdit from "./textResponseEdit";
import TrueFalseQuestionEdit from "./trueFalseQuestionEdit";
import SelectAllThatApplyEdit from "./selectAllThatApplyEdit";
import MultipleChoiceEdit from "./multipleChoiceEdit";
import CodeResponseEdit from "./codeResponseEdit";
import ContextBlockEdit from "./contextBlockEdit";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import BankOfQuestions from "./BankOfQuestionsEdit";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import OnlyIInfo from "./onlyIInfo";
import CompleteOnPaperEdit from "./completeOnPaperEdit";
import LambdaResponseEdit from "./lambdaResponseEdit";
import NotFoundSingleQ from "./notFoundSingleQ";

const CustomExamWrapperEdit = ({ show, counts, updateAssessmentInformation, saveAnswersCritical, assessmentInformation, dockerfileAndFunctionExists, isDarkTheme, updateIsDarkTheme, ignoredPrefixes, updateIsAllowedToScoll, isAllowedToScroll, questionsToSave, ignoredPaths, testsConfigDict, updateQuestionsToSave, contents, updateQuestions, updateIsEditing, updateAddAQuestion, updateDeleteQuestion, questions, useSyntaxHighlighting, zipFileExists }) => {
    const { courseCode, assessmentCode } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const currentId = new URLSearchParams(location.search).get('uuid');

    const typeOfQuestionToReturn = (question, index, provided, showDrag, bankUuid) => {

        switch (question.questionType) {
            case TypesOfQuestionsEnum.TRUE_FALSE: {
                return <TrueFalseQuestionEdit saveAnswersCritical={saveAnswersCritical} counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} explanation={question.explanation} useExplanation={question.useExplanation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} bankUuid={bankUuid} showDrag={showDrag} updateQuestionsToSave={updateQuestionsToSave} provided={provided} key={question.uuid} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType} bubbled={question.bubbled}/>
            }
            case TypesOfQuestionsEnum.SELECT_ALL: {
                return <SelectAllThatApplyEdit saveAnswersCritical={saveAnswersCritical} counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} explanation={question.explanation} useExplanation={question.useExplanation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} bankUuid={bankUuid} showDrag={showDrag}updateQuestionsToSave={updateQuestionsToSave} shuffle={question.shuffle} provided={provided} key={question.uuid} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType} options={question.options} answerArray={question.answerArray}/>
            }
            case TypesOfQuestionsEnum.SHORT_RESPONSE: {
                return <TextResponseEdit counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} saveAnswersCritical={saveAnswersCritical} lastStartTime={question.lastStartTime} autoAssign={question.autoAssign} testStudentResponse={question.testStudentResponse} results={question.results} status={question.status} attempt={question.attempt} isHarsh={question.isHarsh} useAi={question.useAi} modelResponse={question.modelResponse} explanation={question.explanation} useExplanation={question.useExplanation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} bankUuid={bankUuid} showDrag={showDrag} updateQuestionsToSave={updateQuestionsToSave} provided={provided} key={question.uuid} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType}/>
            }
            case TypesOfQuestionsEnum.SCAN_AND_GRADE: {
                return <CompleteOnPaperEdit saveAnswersCritical={saveAnswersCritical} counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} studentsCanUploadScan={question.studentsCanUploadScan} explanation={question.explanation} useExplanation={question.useExplanation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} bankUuid={bankUuid} showDrag={showDrag} updateQuestionsToSave={updateQuestionsToSave} provided={provided} key={question.uuid} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType}/>
            }
            case TypesOfQuestionsEnum.MULTIPLE_CHOICE: {
                return <MultipleChoiceEdit saveAnswersCritical={saveAnswersCritical} counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} explanation={question.explanation} useExplanation={question.useExplanation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} bankUuid={bankUuid} showDrag={showDrag} updateQuestionsToSave={updateQuestionsToSave} shuffle={question.shuffle} provided={provided} key={question.uuid} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType} options={question.options} answerIndex={question.answerIndex}/>
            }
            case TypesOfQuestionsEnum.PROGRAMMING: {
                return <CodeResponseEdit saveAnswersCritical={saveAnswersCritical} counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} dockerfileAndFunctionExists={dockerfileAndFunctionExists} firstTime={question.firstTime} ignoredPrefixes={ignoredPrefixes} explanation={question.explanation} useExplanation={question.useExplanation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} ignoredPaths={ignoredPaths} tests={question.tests} testsConfigDict={testsConfigDict} bankUuid={bankUuid} showDrag={showDrag} updateQuestionsToSave={updateQuestionsToSave} provided={provided} useAutocompletion={question.useAutocompletion} contents={contents} zipFileExists={zipFileExists} key={question.uuid} useSyntaxHighlighting={useSyntaxHighlighting} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType} location={question.location} language={question.language}/>
            }
            case TypesOfQuestionsEnum.CONTEXT_BLOCK: {
                return <ContextBlockEdit saveAnswersCritical={saveAnswersCritical} counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} bankUuid={bankUuid} updateQuestionsToSave={updateQuestionsToSave} provided={provided} key={question.uuid} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType}/>
            }
            case TypesOfQuestionsEnum.BANK_OF_QUESTIONS: {
                return <BankOfQuestions useExplanation={question.useExplanation} updateQuestions={updateQuestions} typeOfQuestionToReturn={typeOfQuestionToReturn} provided={provided} key={question.uuid} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} questions={question.questions} uuid={question.uuid}/>
            }
            case TypesOfQuestionsEnum.LAMBDA: {
                return <LambdaResponseEdit resultsCounts={question.resultsCounts} counts={counts} updateAssessmentInformation={updateAssessmentInformation} assessmentInformation={assessmentInformation} saveAnswersCritical={saveAnswersCritical} lastStartTime={question.lastStartTime} firstTime={question.firstTime} status={question.status} allowedAttempts={question.allowedAttempts ? question.allowedAttempts : 0} attempt={question.attempt} results={question.results} useAutocompletion={question.useAutocompletion} isDarkTheme={isDarkTheme} updateIsDarkTheme={updateIsDarkTheme} useSyntax={question.useSyntax} explanation={question.explanation} useExplanation={question.useExplanation} updateQuestions={updateQuestions} questionsToSave={questionsToSave} testsMap={question.testsMap} bankUuid={bankUuid} showDrag={showDrag} updateQuestionsToSave={updateQuestionsToSave} provided={provided} key={question.uuid} useSyntaxHighlighting={useSyntaxHighlighting} index={index} updateDeleteQuestion={updateDeleteQuestion} points={question.points} question={question.question} uuid={question.uuid} questionType={question.questionType} language={question.language} initAnswer={question.initAnswer}/>
            }
            default: {
                return <></>
            }
        }
    }

    const onDragEnd = (result) => {
        const { destination, source } = result;
    
        // Check if the item was dropped outside the list
        if (!destination) {
            return;
        }
    
        // Check if the item was dropped in the same place
        if (destination.index === source.index) {
            return;
        }

        const newQuestionsOrder = Array.from(questions);
        const [movedQuestion] = newQuestionsOrder.splice(source.index, 1);
        newQuestionsOrder.splice(destination.index, 0, movedQuestion);
        
        updateQuestions(newQuestionsOrder);

        // make api call
        changeOrder(newQuestionsOrder);
    };

    const changeOrder = async (newQuestionsOrder) => {
        const url = process.env.REACT_APP_EVALUATION_API_URL + `/update-question-order`

        const urlOptions = {
            method: "POST",
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                courseCode: courseCode,
                assessmentCode: assessmentCode,
                newQuestionsOrder: newQuestionsOrder.map((question) => question.uuid)
            })
        }

        try {
            const res = await fetch(url, urlOptions);
            const data = await res.json();
            if (res.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            }
        } catch (error) {
            console.log(error);
        }    
    }

    const scrollToBottom = () => {
        const escapedSelector = CSS.escape(questions && questions.length > 0 ? (questions[questions.length - 1].uuid) : "");
        let element = null;

        if (escapedSelector) {
            element = document.querySelector("#" + escapedSelector);
        }

        if (element) {
            element.scrollIntoView({ behavior: "smooth" });         
        }
    };

    useEffect(() => { 
        if (isAllowedToScroll) {
            scrollToBottom()
            updateIsAllowedToScoll(false);
        }
    }, [questions])

    const findSingleQ = (provided) => {
        let topLevelIndex = null;
        let nestedIndex = null;

        for (let i = 0; i < questions?.length; i++) {
            let currentQuestion = questions[i];

            // other than a bank -> trivial solution
            if (currentQuestion.questionType !== TypesOfQuestionsEnum.BANK_OF_QUESTIONS && currentId === currentQuestion.uuid) {
                topLevelIndex = i;
                break;

            } else if (currentQuestion.questionType === TypesOfQuestionsEnum.BANK_OF_QUESTIONS) {
                // we have a bank
                for (let j = 0; j < currentQuestion?.questions?.length; j++) {
                    let currentNestedQuestion = currentQuestion?.questions[j];

                    if (currentNestedQuestion?.uuid === currentId) {
                        topLevelIndex = i;
                        nestedIndex = j;
                        break;
                    }
                }
            }
        }
    
        if (topLevelIndex !== null && nestedIndex !== null) {
            const q = questions[topLevelIndex]?.questions[nestedIndex];
            const cosmetic = (topLevelIndex + 1).toString() + "." + (nestedIndex + 1).toString();

            return typeOfQuestionToReturn(q, cosmetic, provided, true, "");

        } else if (topLevelIndex !== null) {
            return typeOfQuestionToReturn(questions[topLevelIndex], topLevelIndex + 1, provided, true, "");
        }
    
        return <NotFoundSingleQ id={currentId} updateId={() => {
            const searchParams = new URLSearchParams(location.search);
            searchParams.set("uuid", ""); 
            
            navigate(`?${searchParams.toString()}`);
        }}/>;
    };

    return (
        <>
            {
                questions && Object.keys(questions).length > 0

                ?

                <>  
                    <div>

                    </div>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="questionsOrder">
                            {
                                (provided) => (
                                    <div className="custom-exam-wrapper-view" {...provided.droppableProps} ref={provided.innerRef}>
                                        {
                                            show && assessmentInformation?.pollMode && (
                                                <div className="message-logging">
                                                    <div style={{ minWidth: "fit-content" }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                                                        </svg>
                                                    </div>
                                                    Start a live session by activating any one of the following questions and receive real-time, live updates.
                                                </div>
                                            )
                                        }                                        
                                        {       
                                            currentId ? 

                                            findSingleQ(provided)
                                            
                                            :

                                            questions
                                                .map((question, index) => (
                                                    <Draggable key={question.uuid} draggableId={question.uuid} index={index}>
                                                        {
                                                            (provided) => (
                                                                <div
                                                                    {...provided.draggableProps}
                                                                    ref={provided.innerRef}
                                                                    className="draggable-question"
                                                                >{ typeOfQuestionToReturn(question, index + 1, provided, true, "") }</div>
                                                                
                                                            )
                                                        }
                                                    </Draggable>
                                                )
                                            )
                                        }
                                        {provided.placeholder}
                                    </div>
                                )
                            }
                        </Droppable>
                    </DragDropContext>
                </>

                :

                <>
                    <div className="no-questions">
                        <div className="no-assignments-container" style={{ paddingTop: "0px"}}>
                            <div className="no-assignments"> 
                                You currently have no questions
                                <div className="save-changes-2" onClick={() => {
                                    updateIsEditing(true);
                                    updateAddAQuestion(true);
                                }}>
                                    Create A Question
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <OnlyIInfo />
        </>
    );
}

export default CustomExamWrapperEdit;